module.exports = __webpack_public_path__ + "img/thumbnail_ArcticFox_m_normal.0a4178ac.png";